import React from "react";


const About: React.FC = () => <div style={{ margin: 20 }}>About</div>

export default About;